import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { setLocalStorageItem } from '../../utils/localStorage';

function Footer() {
  const { t, i18n } = useTranslation();
  const currentYear = new Date().getFullYear();
  
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    setLocalStorageItem('language', lng);
  };

  return (
    <footer className="bg-dark text-light py-4 py-md-5 mt-auto">
      <div className="container">
        <div className="row g-4 align-items-start">
          {/* Logo and description */}
          <div className="col-12 col-md-4 col-lg-5 text-center text-md-start">
            <div className="d-flex align-items-center justify-content-center justify-content-md-start mb-3">
              <img 
                src="/images/favicon/favicon.svg" 
                alt="TapDonkey Logo" 
                width="32" 
                height="32"
                className="me-2"
              />
              <span className="fw-semibold fs-5">TapDonkey</span>
            </div>
            <p className="small text-secondary mb-0">{t('footer.description')}</p>
          </div>
          
          {/* Essential links */}
          <div className="col-12 col-md-4 col-lg-4 text-center text-md-start">
            <ul className="list-unstyled d-flex flex-column flex-sm-row gap-3 gap-md-4 justify-content-center justify-content-md-start mb-0">
              <li>
                <Link to="/about" className="text-secondary text-decoration-none small">
                  {t('footer.about')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-secondary text-decoration-none small">
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-secondary text-decoration-none small">
                  {t('footer.terms')}
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Language selector */}
          <div className="col-12 col-md-4 col-lg-3 text-center text-md-end">
            <div className="dropdown d-inline-block">
              <button 
                className="btn btn-sm btn-outline-secondary dropdown-toggle px-4" 
                type="button" 
                data-bs-toggle="dropdown" 
                aria-expanded="false"
              >
                {t(`common.languages.${i18n.language}`)}
              </button>
              <ul className="dropdown-menu dropdown-menu-dark dropdown-menu-end">
                <li><button className="dropdown-item small" onClick={() => changeLanguage('en')}>English</button></li>
                <li><button className="dropdown-item small" onClick={() => changeLanguage('de')}>Deutsch</button></li>
                <li><button className="dropdown-item small" onClick={() => changeLanguage('lv')}>Latviešu</button></li>
                <li><button className="dropdown-item small" onClick={() => changeLanguage('zh')}>中文</button></li>
              </ul>
            </div>
          </div>
        </div>
        
        <hr className="my-4 border-secondary opacity-25" />
        
        {/* Copyright */}
        <div className="row">
          <div className="col-12">
            <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-2 text-center text-sm-start">
              <p className="text-secondary small mb-0">&copy; {currentYear} {t('footer.copyright')}</p>
              <p className="text-secondary small mb-0">
                <a href={t('footer.formilisLink')} target="_blank" rel="noopener noreferrer" className="text-secondary text-decoration-none">{t('footer.madeBy')}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 